export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ro.c602aaf73a74bf18.json"